import { render, staticRenderFns } from "./detail_spklu_ac.vue?vue&type=template&id=0a9e95cb&scoped=true&"
import script from "./detail_spklu_ac.vue?vue&type=script&lang=js&"
export * from "./detail_spklu_ac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e95cb",
  null
  
)

export default component.exports